<ptl-v3-filter-shell [title]="'translations.filter.role.name' | transloco" (applied)="applyFilter()" (deleted)="deleteFilter()">
  <ng-container ngProjectAs="[shell-controls]">
    <ptl-select
      class="v3-role-filter__select"
      [options]="roleIsOptions"
      [ngModel]="roleIs"
      (selectionChange)="onRoleIsSelection($event)"
    ></ptl-select>
    @if (roleIs) {
      <ptl-select
        class="v3-role-filter__select"
        [options]="operatorOptions"
        [ngModel]="logicalOperator"
        (selectionChange)="onLogicalOperatorSelection($event)"
      ></ptl-select>
    }
  </ng-container>
  <div class="v3-role-filter__list">
    @for (role of roles; track role.role._id) {
      <ptl-sg-checkbox
        class="v3-role-filter__item"
        [checked]="role.value"
        [ariaLabel]="
          role.value
            ? ('translations.global.ariaLabels.uncheckRoleFilter' | transloco: { roleName: role.label })
            : ('translations.global.ariaLabels.checkRoleFilter' | transloco: { roleName: role.label })
        "
        (checkboxChange)="changeRole(role.role)"
      >
        <span class="v3-role-filter__item-label">{{ role.label }}</span>
      </ptl-sg-checkbox>
    }
  </div>
</ptl-v3-filter-shell>
